import { ReactElement } from 'react';
import PaymentArrangements from '@components/FVSPage/PaymentArrangements';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep20(): ReactElement {
  return (
    <>
      <PaymentArrangements displayObject={fvsInfoDisplayObject} currentStepNo="step20" />
    </>
  );
}

export default FVSStep20;
